var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 307.191,
    height: 310,
    viewBox: "0 0 307.191 310",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_832",
    "data-name": "Group 832",
    transform: "translate(0 -7.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M76.04,415.54H220.465v27.651H76.04Z",
    transform: "translate(-29.316 -157.312)",
    fill: "#a17855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M287.37,425.685v17.506H265.55L249.58,415.54h31.934Z",
    transform: "translate(-96.221 -157.312)",
    fill: "#896848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M310.528,431.137H278.6L263,404.125l-15.97-27.651L219.07,328.036l23.946-13.826Z",
    transform: "translate(-84.458 -118.246)",
    fill: "#b28b6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M253.6,314.21l-7,4.043,48.2,83.47a12.289,12.289,0,0,1-10.643,18.434h-1.309l6.4,10.981H321.2Z",
    transform: "translate(-95.072 -118.246)",
    fill: "#a17855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M113.824,415.54l-15.97,27.651H76.04V425.673l5.85-10.133Z",
    transform: "translate(-29.316 -157.312)",
    fill: "#896848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M50.778,431.137H19.2L86.712,314.21l23.682,13.672.264.154L82.693,376.474l-15.97,27.651-15.6,27.012",
    transform: "translate(-7.402 -118.246)",
    fill: "#b28b6a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    cx: 114.328,
    cy: 114.328,
    r: 114.328,
    transform: "translate(4.609 7.5)",
    fill: "#eb304a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M121.791,130.578a4.609,4.609,0,0,0,4.6,4.621h8.086l34.632.1,34.558.1,31.676.092a114.4,114.4,0,1,1,.811-13.666q0,2.249-.086,4.473l-31.4-.092-33.863-.1-31.025-.092-13.377-.037a4.609,4.609,0,0,0-4.609,4.6Z",
    transform: "translate(-2.891 0)",
    fill: "#eb304a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M235.039,135.322l-34.632-.1h-8.086a4.614,4.614,0,1,1-.461-9.217h-8.732a4.609,4.609,0,1,0,0,9.217h8.086l34.632.1,34.558.1,31.676.092a114.353,114.353,0,0,1-108.9,100.533c1.518.061,3.042.1,4.578.1A114.342,114.342,0,0,0,301.273,135.519l-31.676-.092ZM187.762,7.5c-1.542,0-3.072.037-4.609.1a114.324,114.324,0,0,1,109.714,114.23q0,2.243-.086,4.449H302q.08-2.218.086-4.473A114.32,114.32,0,0,0,187.762,7.5Z",
    transform: "translate(-68.825 0)",
    fill: "#e4222e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    cx: 82.953,
    cy: 82.953,
    r: 82.953,
    transform: "translate(35.983 38.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M141.477,150.248a4.609,4.609,0,0,0,4.6,4.621h8.086l34.632.1,34.558.1a82.975,82.975,0,1,1,1.118-13.6q0,2.2-.117,4.381l-33.863-.1-31.025-.092-13.377-.012a4.609,4.609,0,0,0-4.609,4.6Z",
    transform: "translate(-22.577 -19.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    cx: 49.158,
    cy: 49.158,
    r: 49.158,
    transform: "translate(69.779 72.671)",
    fill: "#eb304a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M162.678,171.469a4.609,4.609,0,0,0,4.6,4.621h8.086l34.632.1a49.158,49.158,0,1,1,1.88-13.518q0,2.163-.184,4.3l-31.025-.092-13.377-.006a4.609,4.609,0,0,0-4.609,4.6Z",
    transform: "translate(-43.778 -40.89)",
    fill: "#eb304a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 18.434,
    cy: 18.434,
    r: 18.434,
    transform: "translate(100.503 103.394)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M181.956,190.717a4.609,4.609,0,0,0,4.6,4.621h8.086a18.434,18.434,0,1,1,5.788-13.4,18.109,18.109,0,0,1-.485,4.191l-13.377-.012a4.609,4.609,0,0,0-4.609,4.6Z",
    transform: "translate(-63.056 -60.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M359.141,200.782q-.178,4.664-.725,9.217l-31.676-.092a81.3,81.3,0,0,0,1-9.217Z",
    transform: "translate(-125.968 -74.481)",
    fill: "#e4222e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M306.059,200.624a81.307,81.307,0,0,1-1,9.217l-34.558-.1a49.032,49.032,0,0,0,1.7-9.217Z",
    transform: "translate(-104.286 -74.415)",
    fill: "#efe5dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M250.467,200.468a49.033,49.033,0,0,1-1.7,9.217l-34.631-.1a18.342,18.342,0,0,0,5.3-9.217Z",
    transform: "translate(-82.557 -74.357)",
    fill: "#e4222e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M211.478,200.38a18.342,18.342,0,0,1-5.3,9.217h-8.086a4.609,4.609,0,0,1,0-9.217Z",
    transform: "translate(-74.592 -74.361)",
    fill: "#e1e1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M355.745,195l-157.636-.461a4.609,4.609,0,0,1,0-9.217l157.636.461a4.609,4.609,0,1,1,0,9.217Z",
    transform: "translate(-74.6 -68.555)",
    fill: "#57565c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M459.753,164.327l-16.173,15.362a1.843,1.843,0,0,0,0,2.673l16.24,15.454a1.843,1.843,0,0,1-1.272,3.177l-40.248-.111a1.844,1.844,0,0,1-1.266-.5L397.95,182.239a1.843,1.843,0,0,1,0-2.673l18.969-18.022a1.844,1.844,0,0,1,1.278-.5l40.278.111a1.843,1.843,0,0,1,1.278,3.177Z",
    transform: "translate(-153.201 -59.194)",
    fill: "#fddd5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M472.73,197.795l-16.259-15.454a1.843,1.843,0,0,1,0-2.673l16.173-15.362a1.843,1.843,0,0,0-1.266-3.177l-40.254-.135a.939.939,0,0,0-.264,0l31.338.086a1.843,1.843,0,0,1,1.266,3.177l-16.173,15.362a1.843,1.843,0,0,0,0,2.673l16.222,15.5a1.843,1.843,0,0,1-.959,3.152h8.9a1.843,1.843,0,0,0,1.272-3.152Z",
    transform: "translate(-166.11 -59.173)",
    fill: "#fed030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M235.987,506.217H180.341a4.609,4.609,0,1,1,0-9.217h55.646a4.609,4.609,0,1,1,0,9.217Zm-177.576,0H4.609a4.609,4.609,0,1,1,0-9.217h53.8a4.609,4.609,0,1,1,0,9.217Z",
    transform: "translate(0 -188.717)",
    fill: "#896848"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.cf270ef26497322b729a81096f178cb0.svg";
export { ForwardRef as ReactComponent };